import { arrayOf, func, object, string } from 'prop-types';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import qs from 'qs';
import BaseAd from 'oxygen-lib-ui/components/Ad';
import { getSlotId, templateToObj } from './helper';

// Track initialized ad slots
// Note, this is only initialized client side since we do not want this shared
// between server requests
const slots = typeof window !== 'undefined' ? new Map() : undefined;

if (typeof window !== 'undefined') {
  // Attach a single event listener to handle post messages for all slots
  window.addEventListener(
    'message',
    ({ origin, data }) => {
      // Only act on message if it is a trusted origin, i.e. the current origin
      // or a known Google origin
      if (
        origin === window.location.origin ||
        /https?:\/\/(.*).googlesyndication.com/.test(origin)
      ) {
        // Message is from DFP
        // Check for matching slot
        const slot = slots.get(data.slotId);
        if (slot) {
          // Slot is mounted. Call onPostMessage handler.
          slot.onPostMessage(data.type, data.template);
        }
      }
    },
    false
  );
}

export class Ad extends Component {
  constructor(props) {
    super(props);
    const location = process.browser ? window.location : undefined;
    const { tags, categories, recipe } = props.targeting || {};
    const targeting = {
      ...{ tags, categories, recipe },
      ...{
        // Add post id targeting
        post_id: props.post ? props.post.resourceId : '',
        // Add targeting that relies on window.location
        ...(location
          ? {
              pathname: location.pathname,
              utm_source: qs.parse(location.search.slice(1)).utm_source
            }
          : {})
      }
    };

    const slotId = getSlotId(props.unit, slots);

    this.state = {
      slotId,
      targeting
    };

    this.handleTemplate = this.handleTemplate.bind(this);

    if (slots) {
      // Add slot to map
      slots.set(slotId, {
        onPostMessage: this.handleTemplate
      });
    }
  }

  componentWillUnmount() {
    // Remove slot from map
    slots.delete(this.state.slotId);
  }

  handleTemplate(type, template) {
    this.setState({
      template: {
        [type]: templateToObj(type, template)
      }
    });
  }

  render() {
    const { template } = this.state;
    const { flips, pusher } = this.props;
    // Replace original targeting (stringified JSON) with (augmented) parsed
    // targeting object
    const parsed = Object.assign({}, this.props, {
      targeting: this.state.targeting,
      showDebug: flips.includes('flip_show_ad_debug'),
      ...(flips.includes('flip_show_test_ads')
        ? { unit: '/6782/ProductTeam' }
        : {})
    });

    return (
      <Fragment>
        <BaseAd id={this.state.slotId} {...parsed} />
        {template && template.pusher && pusher && pusher(template.pusher)}
      </Fragment>
    );
  }
}

Ad.defaultProps = {
  targeting: {},
  flips: [],
  pusher: undefined
};

Ad.propTypes = {
  unit: string.isRequired,
  targeting: object, // eslint-disable-line
  flips: arrayOf(string),
  pusher: func
};

export default connect(({ app }) => ({
  flips: app.flips
}))(props =>
  props.flips.includes('flip_disable_banner_ads') ? null : <Ad {...props} />
);
